import { dcolors, dlog, TObject } from "corexxx";
import { useDAppCommand } from "../../libs/dweb/DAppCommand";
import React from "react";
import { DCol } from "../../libs/dweb/DCol";
import { DPageHeader } from "../../libs/dweb/DPageHeader";
import { DSelectInput } from "../../libs/dweb/DSelectInput";
import { DBox } from "../../libs/dweb/DBox";
import { debug } from "console";
import { processtickerHistoryResp } from "./helper";
import { DRow } from "../../libs/dweb/DRow";
import { DText } from "../../libs/dweb/DText";
import { DCalender } from "../../libs/dweb/DCalender";

export function StockTrendsFinderView() {
  let appCommand = useDAppCommand();
  //let [candleType, setCandleType] = React.useState("1d");
  let [symbol, setSymbol] = React.useState("META");
  let candleTypeList = ['1d', '1w', '1mo'];
  let [stockData, setStockData] = React.useState<TObject[]>([]);

  React.useEffect(() => {
    let fetchStockData = async () => {
      let data: TObject[] = [];
      candleTypeList.forEach(async (candleType) => {
        let priceData = await appCommand.api.getSimpleStore("/api/utils/schwab/longpricehistory?symbol=" + symbol + "&interval=" + candleType);
        data.push({ candleType: candleType, candles: processtickerHistoryResp(priceData.out).slice(-100) });
      });
      setStockData(data);
    }
    fetchStockData();
  }, [symbol]);

  return (
    <DCol>
      <DBox style={{ flex: 0 }}>
        <DRow>
          <DCol>
            <DPageHeader style={{ borderTop: '5px solid black', borderBottom: '5px solid black', padding: 10, marginBottom: 10 }} title="Stock Trades" rightView={<>
              <DSelectInput value={symbol} onChange={setSymbol} options={['AAPL', 'GOOGL', 'MSFT', 'AMZN', 'TSLA', 'META', 'NVDA']} />
            </>}></DPageHeader>
          </DCol>
          <DCalender />
        </DRow>
        {/*stockData.map((stock, i) => {
          return (<DRow center style={{ flex: 0, marginBottom: 30 }}>
            <DText style={{ width: 50 }}>{stock.symbol}:</DText>
            {stock.candles.map((candle: any, j: any) => {
              return <div style={{ width: 15, height: 15, marginRight: 1, background: candle.color }} title={`${candle.close.toFixed(2)}(${candle.pchange.toFixed(2)}%)`}></div>
            })}
          </DRow>)
        })*/}

      </DBox>
    </DCol>
  );
}






